import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { AbstractControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { type FormQuestionState, QuestionType } from '@pixacare/forms';
import { TuiInput, TuiLabel, TuiTextfieldComponent } from '@taiga-ui/core';
import { TuiInputDate, TuiSwitch, TuiTextarea } from '@taiga-ui/kit';
import { FormIconPipe } from '../../../pipes/form-icon.pipe';
import { FormDisplayMode } from '../../form-grid/models/form-display-mode';
import { FormQuestionCheckboxComponent } from '../form-question-checkbox/form-question-checkbox.component';
import { FormQuestionNumberComponent } from '../form-question-number/form-question-number.component';
import { FormQuestionRadioComponent } from '../form-question-radio/form-question-radio.component';

@Component({
  selector: 'pxc-form-question-input',
  templateUrl: './form-question-input.component.html',
  styleUrl: './form-question-input.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.grid-mode]': "mode() === 'grid'",
    '[class.read-only]': 'isReadOnly()',
    '[class.bool-type]': 'question().type === QuestionType.BOOL',
    '[class.pointer-events-none]': 'isReadOnly()',
  },
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslocoDirective,
    TuiTextfieldComponent,
    TuiInput,
    TuiTextarea,
    TuiSwitch,
    TuiInputDate,
    TuiLabel,
    FormIconPipe,
    FormQuestionNumberComponent,
    FormQuestionRadioComponent,
    FormQuestionCheckboxComponent,
  ],
})
export class FormQuestionInputComponent {
  readonly control = input.required<AbstractControl>();
  readonly question = input.required<FormQuestionState>();
  readonly mode = input<FormDisplayMode>('form');
  readonly readOnly = input<boolean>(false);

  readonly QuestionType = QuestionType;

  readonly isReadOnly = computed(() => this.question().parameters?.readonly || this.readOnly());
  readonly isForm = computed(() => this.mode() === 'form');

  readonly checkboxControl = computed(() => this.control() as FormGroup);
}
